import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsInternationalAndDomesticTerrorismEngagementItemValidator from './validators/items';
import { LegalAssociationsInternationalAndDomesticTerrorismEngagementModel } from './types';

const legalAssociationsInternationalAndDomesticTerrorismEngagementValidator: ValidateJSModel<LegalAssociationsInternationalAndDomesticTerrorismEngagementModel> = {
  HasInternationalAndDomesticTerrorismEngagement: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInternationalAndDomesticTerrorismEngagement?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsInternationalAndDomesticTerrorismEngagementItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsInternationalAndDomesticTerrorismEngagementValidator;
